import { css } from "@emotion/react";

export const checkboxGroupContent = css`
  padding: 0 10px;
  max-height: 265px;
  overflow: auto;
  label {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`;

export const searchContainer = css({
  marginBottom: "10px",
  marginLeft: "1px", // reserve space for input outline
  marginRight: "1px", // reserve space for input outline
});
